import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'exa-criteria',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class CriteriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
